import styled, {css} from "styled-components"

import Card from "@irati/ui/src/Layout/Card"

const ElevatedCard = styled(Card)`
  ${({theme}) => css`
    margin-top: 20px;
    box-shadow: ${theme.shadows.mid};
    ${theme.mediaQueries.minWidthMedia.desktop`
      margin-top: 0;
    `}
  `}
`

export default ElevatedCard
